import React from 'react';
import PropTypes from 'prop-types';
import { captureException } from '@shared/utils';
import { SENTRY_ERROR_TYPES } from '@shared/constants';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { error: null };
	}

	static getDerivedStateFromError(error) {
		return { error: !!error };
	}

	componentDidCatch(error, errorInfo) {
		this.setState({ error });
		captureException(error, {
			extras: errorInfo,
			tags: {
				errorType: SENTRY_ERROR_TYPES.Component,
			},
		});
	}

	render() {
		const { error } = this.state;
		const { children } = this.props;
		if (error) {
			// render fallback UI
			return <React.Fragment />;
		}
		// when there's not an error, render children untouched
		return children;
	}
}
ErrorBoundary.defaultProps = {
	children: null,
};

ErrorBoundary.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
};

export default ErrorBoundary;
